import React from 'react';

export default function ExperienceStats() {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="bg-[#1E4363] p-6 rounded-sm text-center shadow-md">
        <h4 className="text-3xl font-bold text-white mb-1">23+</h4>
        <p className="text-[#F9F8F3]/70 text-xs uppercase tracking-wider font-semibold">Years Experience</p>
      </div>
      <div className="bg-[#87412A] p-6 rounded-sm text-center shadow-md">
        <h4 className="text-3xl font-bold text-white mb-1">9+</h4>
        <p className="text-[#F9F8F3]/70 text-xs uppercase tracking-wider font-semibold">Years in Command</p>
      </div>
    </div>
  );
}